import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
import NavBreadcrum from "components/NavBreadcrum";
//-
import navs from "./navs";
import axiApi from "ApiCaller";
import {SwalAlertClass, SwalAlertChoice} from "core/swalClass";
import TableFirmware from "./firmware/TableFirmware";
import TopBarActions from "components/TopBarActions";
import ButtonsActions from "../utils/buttonsActions";
import FormFirmware from "./firmware/FormFirmware";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import OrderingModel from "components/ordering/OrderingModel";
import ItemsModel from "core/itemsModel";

const buttonsActions = new ButtonsActions();

const ViewFirmware = () => {
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tt} = useTranslation("tables");

    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const AlertQuestion = new SwalAlertChoice({
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
    });
    const bread = [
        {name: _Tr("labels.advanced"), url: "/advanced/", current: false},
        {name: _Tr("labels.firmware"), current: true},
    ];
    document.title = _Tr("labels.firmware");

    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const orderingRef = useRef(new OrderingModel());

    const [itemsShown, setItemsShown] = useState([]);
    const [buttonsTB, setButtonsTB] = useState({
        ...new ButtonsActions(),
        title: document.title,
    });
    const [showForm, setShowForm] = useState(false);
    const [models, setModels] = useState([]);
    // filters
    const [isLoading, setIsLoading] = useState(false);
    const [item, setItem] = useState({});
    const [checkAll, setCheckAll] = useState(false);
    const [showPrev, setShowPrev] = useState(false);

    const headersTable = [
        {name: _Tt("common.name"), attr: 0, direction: "asc", active: true, default: true},
        {name: _Tt("labels.measured_at"), attr: 1, direction: "asc", active: false},
        {name: _Tt("devices.model"), attr: 2, direction: "asc", active: false},
        {name: _Tt("labels.version"), attr: 3, direction: "asc", active: false},
        {name: _Tt("labels.size"), attr: 4, direction: "asc", active: false},
    ];

    useEffect(() => {
        let buttons = {...buttonsTB};
        buttons.title = document.title;
        buttons.add.active = true;
        buttons.add.disabled = false;
        buttons.add.onClick = onClickAdd;
        buttons.delete.active = true;
        buttons.delete.disabled = true;
        buttons.delete.onClick = onClickDelete;
        setButtonsTB(buttons);
        pagerModelRef.current.handleCallApi = () => fetchFirmware();
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => fetchFirmware();
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPrev;
        items.current.item = {};
        fetchGetFirmware();
        filters.current.filter = (e) => {
            pagerModelRef.current.paging.page = 1;
            fetchFirmware();
        };
    }, []);

    const fetchGetFirmware = () => {
        setIsLoading(true);
        axiApi
            .get("/api/devices/advanced/blobs/")
            .then((resp) => {
                pagerModelRef.current.active = resp.data.items.length > 0;
                items.current.showed = [...resp.data.items];
                setItemsShown([...resp.data.items]);

                setModels(resp.data.models);
                if (resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const fetchFirmware = () => {
        setIsLoading(true);
        axiApi
            .post("/api/devices/advanced/blobs/", filters.current.chosen, {
                params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
            })
            .then((resp) => {
                pagerModelRef.current.active = resp.data.items.length > 0;
                items.current.setShowed(resp.data.items);
                setItemsShown([...resp.data.items]);
                if (resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const onClickAdd = () => {
        setShowForm(true);
    };

    const onClickDelete = () => {
        AlertQuestion.fire("Se solicitara", `La eliminación de ${items.current.chosen.length} archivos`).then((r) => {
            if (r.isConfirmed) {
                axiApi
                    .delete("/api/devices/advanced/files/", {
                        data: {ids: items.current.getChosenIds()},
                    })
                    .then((resp) => {
                        if (resp.data.status) {
                            items.current.checkBoxes = [];
                            if (resp.data.deleted.items.length) {
                                Alert.success(
                                    "Borrado",
                                    `Se han borrado los ${resp.data.deleted.items.length} archivos seleccionados.\n 
                                         Afectando a ${resp.data.deleted.counter} dispositivos.`,
                                );
                                let deletedIds = resp.data.deleted.items.map((item) => item.id);

                                let remainingItems = items.current.showed.filter((item) => !deletedIds.includes(item.id));

                                items.current.showed = [...remainingItems];
                                setItemsShown([...remainingItems]);
                                items.current.clearChosen();
                            }
                            if (resp.data.errors.length) {
                                Alert.error(
                                    "Error",
                                    `Se han encontrado ${resp.data.errors.length} errores al borrar los archivos.`,
                                );
                            }
                        }
                    });
            }
        });
    };
    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" chosen={items.current.chosen} />
            <div className="row">
                <LoaderSpinner isLoading={isLoading}>
                    <TableFirmware
                        items={items}
                        itemsShow={itemsShown}
                        checkAll={checkAll}
                        setCheckAll={setCheckAll}
                        buttonsTB={buttonsTB}
                        setButtonsTB={setButtonsTB}
                        orderingRef={orderingRef}
                    />
                    <label className={itemsShown.length === 0 ? "" : "d-none"}>No hay resultados que mostrar</label>
                </LoaderSpinner>
            </div>
            <FormFirmware show={showForm} setShow={setShowForm} models={models} items={items} setItemsShown={setItemsShown} />
        </>
    );
};
export default ViewFirmware;
